import { LOCAL_STORAGE_KEY_JWT } from '@/api'
import LogoHorizontal from '@/assets/icons/logo-horizontal.svg?react'
import { useFetchUser } from '@/features/authorization/api/useFetchUser'
import { useSessionProvider } from '@/features/authorization/components/SessionProvider'
import { routes } from '@/pages'
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/ui-kit'
import { useLocalStorage } from '@/utils/useLocalStorage'
import { clsx } from 'clsx'
import { LogOut, Menu, UserRound, X } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'

export const MissionsHeader = ({
  isMenuOpened,
  setIsMenuOpened
}: {
  isMenuOpened: boolean
  setIsMenuOpened: (value: boolean | ((value: boolean) => boolean)) => void
}) => {
  const [jwt] = useLocalStorage(LOCAL_STORAGE_KEY_JWT, '')
  const { data: user } = useFetchUser(!!jwt)
  const { logout } = useSessionProvider()
  const navigate = useNavigate()

  return (
    <header className="bg-background max-tablet:px-4 max-mobile:px-5 sticky top-0 z-[2] flex h-[var(--header-height)] items-center justify-between gap-4 border-b border-solid border-[var(--color-gray-100)] py-4 pr-6 pl-10">
      <ul
        className={clsx('max-mobile:flex -m-4 hidden cursor-pointer flex-col gap-[6px] p-4')}
        onClick={() => setIsMenuOpened((value) => !value)}
      >
        {isMenuOpened ? <X /> : <Menu />}
      </ul>
      <Link
        to={routes.missions.path}
        onClick={() => {
          setTimeout(() => setIsMenuOpened(false), 250)
        }}
        className="max-mobile:ml-6 flex min-w-0 cursor-pointer items-center gap-3 max-[600px]:absolute max-[600px]:left-1/2 max-[600px]:ml-0 max-[600px]:-translate-x-1/2"
      >
        <span className="text-subtitle truncate text-[22px] font-semibold">Missions</span> <LogoHorizontal />
      </Link>

      <div className="ml-auto flex shrink-0 items-center">
        {jwt ? (
          <DropdownMenu modal>
            <DropdownMenuTrigger className="border-0 bg-transparent p-0!" showChevron={false}>
              <Button variant="bordered-gray" size="small" className="flex items-center gap-2">
                <UserRound className="text-gray-70 size-5 shrink-0" />
                <span className="text-gray-70 text-body-2 truncate text-left">{user?.email ?? 'Sign In'}</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" sideOffset={8} className="min-w-[200px]">
              <DropdownMenuItem asChild className="text-gray-80 hover:text-orange rounded-none py-3">
                <Link to={routes.profile.path} className="text-body2-regular flex cursor-pointer items-center gap-2">
                  <UserRound className="size-4 shrink-0" aria-hidden />
                  Profile
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem
                className="text-gray-80 hover:text-orange flex cursor-pointer items-center gap-2 rounded-none py-3"
                onSelect={() => {
                  void logout()
                }}
              >
                <LogOut className="size-4 shrink-0" aria-hidden />
                Logout
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : (
          <Button
            variant="bordered-gray"
            size="small"
            className="flex items-center gap-2"
            onClick={() => navigate(routes.login.path)}
          >
            <UserRound className="text-gray-70 size-5 shrink-0" />
            <span className="text-gray-70 text-body-2 truncate text-left">Sign In</span>
          </Button>
        )}
      </div>
    </header>
  )
}
